import { injectIntl } from "react-intl"
import { InventorySection } from "./InventorySection"

export const ProductInventorySection = injectIntl(InventorySection)


// WEBPACK FOOTER //
// ./src/product/sections/index.ts